import React from 'react'
import { Card, CardBody, Col, Row } from "reactstrap";

// component
import WlCardHeader from "../components/WlCardHeader";
import WlCardComment from "../components/WlCardComment";
import WishlistButtons from "../tools/WishlistButtons";

// label
import {
    LB_ADULTS, LB_CARGO_HAB, LB_CHILDREN, LB_DATE,
    LB_HOUR, LB_INFANTS, NO, YES_CONFIRM,
} from "../../i18n/i18n";

// utils
import { getWishlistOption, wishlistTypes } from "../../../util/WishlistUtils";

const AfiViewComponent = props => {
    const option = getWishlistOption( wishlistTypes?.afi )

    return <Card className={'wl-card'}>
        <CardBody className={'wl-card-content'}>
            <WlCardHeader
                icon={ option?.icon }
                title={ option?.title }
                subTitle={props?.component?.title}
                pax={props?.component?.pax}
            />

            <div className={'wl-card-body ptb-1em mb-1em'}>
                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_DATE}</label> &nbsp;
                            <label className={'wl-label-value'}> {props?.component?.date}</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_ADULTS}</label> &nbsp;
                            <label
                                className={'wl-label-value'}> {props?.component?.adults || props?.component?.pax} </label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_INFANTS}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.infants || 0}</label>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_HOUR}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.hour}</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_CHILDREN}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.childs || 0}</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_CARGO_HAB}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.roomCharge ? YES_CONFIRM : NO}</label>
                        </div>
                    </Col>
                </Row>
            </div>

            <WlCardComment comment={props?.component?.comments}/>

            <WishlistButtons from={'wishlist'} {...props} />
        </CardBody>
    </Card>
}

export default AfiViewComponent